module.exports = "<div>\n    <ssf-confirm-dialog class=\"ssf-app-list-item__button\"\n                        (onConfirm)=\"onSaveChanges()\"\n                        [popDisabled]=\"!(btnEnabled | async)\"\n                        headerTitle=\"{{i18n + 'CONFIRMATION-MESSAGE' | translate}}\">\n        <ssf-button\n            btnText=\"{{i18n + 'BUTTON-LABEL' | translate}}\"\n            [btnDisabled]=\"!(btnEnabled | async)\"\n        ></ssf-button>\n    </ssf-confirm-dialog>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/consent/components/consent/consent.component.html
// module id = 827
// module chunks = 3